export default "__VITE_ASSET__DiUaDfpl__"